import { useState, useEffect } from 'react';
import { publicAssetUrl } from '@/services/gameApi';

function loadImage(fileName: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Failed to load ${fileName}`));
    img.src = publicAssetUrl(fileName);
  });
}

export function useRoverSprites() {
  const [roverSprites, setRoverSprites] = useState<HTMLImageElement[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const sprites = await Promise.all(
          [1, 2, 3, 4].map((frame) => loadImage(`rover-front-frame${frame}.png`)),
        );
        if (!cancelled) setRoverSprites(sprites);
      } catch (err) {
        if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to load rover sprites');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { roverSprites, loading, error };
}
